import React, { useState, useEffect, useRef } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Collapse from "@material-ui/core/Collapse";
import A_IconButton from "../../../../Atoms/Inputs/Buttons/A_IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TuneIcon from "@material-ui/icons/Tune";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LockIcon from "@material-ui/icons/Lock";
import Typography from "@material-ui/core/Typography";
import { LayoutMenusStructure } from "./LayoutMenu";
import { useParams } from "react-router";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ClientLogoComponent from "./clientLogo";
import { useDispatch } from "react-redux";
import { getCurrentEventValue } from "../../../../../../store/actions/getEventValueAction";
import A_SimpleDialog from "../../../../Atoms/Feedback/Dialogs/A_SimpleDialog";
import A_Button from "../../../../Atoms/Inputs/Buttons/A_Button";
import M_Preferences from "../M_Preferences/M_Preferences";
import { getCRMContactInfo } from "../../../../../../Utils/Helpers/common";
import M_MenuIcon, {
  hasMenuIcon,
  stripMenuIconPrefix,
  startsWithBackArrow,
} from "./M_MenuIcon";
import Tooltip from "@material-ui/core/Tooltip";
import { useStyles } from "./M_LayoutMenu.styles";
import { getStoredSidebarVibrant } from "../M_ThemeSelector/M_ThemeSelector.helper";
import {
  isTemplateHidden,
  isTemplateDisabled,
  getLockedMessage,
} from "../../../../Pages/Common/Layouts/layout.Helper";

const PREFERENCES_MENU_LABEL = "Preferences";
const PREFERENCES_DIALOG_TITLE = "Preferences";
const COLLAPSED_SECTIONS_STORAGE_KEY = "layoutMenu.collapsedSections";

const getInitials = (str) => {
  if (!str) return "";
  return str
    .split(/\s+/)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
};

const readCollapsedSections = () => {
  try {
    const raw = localStorage.getItem(COLLAPSED_SECTIONS_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const M_LayoutMenu = React.memo((props) => {
  const classes = useStyles();
  const { isRailMode = false } = props;
  const isCompact = Boolean(isRailMode);
  const [layouts, setlayouts] = useState(LayoutMenusStructure(props.layouts));

  const [layoutsmenus, setLayoutsmenus] = useState([]);
  let { crmId } = useParams();
  const [currentuser, setCurrentuser] = React.useState("");
  const [menuItem, setMenuItem] = useState("");
  const [isMsgOpen, setIsMsgOpen] = useState(false);
  const [openPreferencesDialog, setOpenPreferencesDialog] = useState(false);
  const [collapsedSections, setCollapsedSections] = useState(
    readCollapsedSections
  );
  const [vibrant, setVibrant] = useState(getStoredSidebarVibrant);
  const scrollAreaRef = useRef(null);
  const activeItemRef = useRef(null);
  const eventValue = useSelector((state) => state.getEventValueStore);
  const currentPageData = useSelector((state) => state.currentPage?.data);
  const dispatch = useDispatch();
  const _userid = useSelector((state) =>
    state?.getLoggedInUserReducer?.data?.[0]?.id
      ? state.getLoggedInUserReducer.data[0].id
      : ""
  );
  const { isUserSuperAdmin } = getCRMContactInfo();
  const UserPageProfile = crmId == currentuser;
  let loggedInUserDetail = JSON.parse(localStorage.getItem("contact_crm"));
  const userid =
    loggedInUserDetail && loggedInUserDetail.id
      ? loggedInUserDetail.id
      : _userid;

  const searchtext = "";
  useEffect(() => {
    setCurrentuser(userid);
  }, [userid]);

  useEffect(() => {
    setlayouts(LayoutMenusStructure(props.layouts));
  }, [props.layouts]);

  useEffect(() => {
    try {
      localStorage.setItem(
        COLLAPSED_SECTIONS_STORAGE_KEY,
        JSON.stringify(collapsedSections)
      );
    } catch {
      return;
    }
  }, [collapsedSections]);

  useEffect(() => {
    const syncVibrant = () => setVibrant(getStoredSidebarVibrant());
    window.addEventListener("themeChange", syncVibrant);
    return () => window.removeEventListener("themeChange", syncVibrant);
  }, []);

  useEffect(() => {
    const el = activeItemRef.current;
    const container = scrollAreaRef.current;
    if (!el || !container) return;
    const margin = 8;
    const elTop = el.offsetTop;
    const elBottom = elTop + el.offsetHeight;
    const viewTop = container.scrollTop;
    const viewBottom = viewTop + container.clientHeight;
    if (elTop < viewTop) {
      container.scrollTop = elTop - margin > 0 ? elTop - margin : 0;
    } else if (elBottom > viewBottom) {
      container.scrollTop = elBottom - container.clientHeight + margin;
    }
  }, [props.currentPageId, layoutsmenus, isCompact]);
  
  let clientName =
    window.location &&
      window.location.hostname &&
      window.location.hostname.split(".") &&
      window.location.hostname.split(".").length > 0
      ? window.location.hostname.split(".")[0]
      : "";

  React.useEffect(() => {
    const results = layouts.filter((layout) => {
      if (
        layout &&
        layout.name &&
        layout.name.toLowerCase().includes(searchtext)
      ) {
        return true;
      } else if (layout && layout.children && layout.children.length > 0) {
        let res = layout.children.filter((child) =>
          child.name.toLowerCase().includes(searchtext)
        );
        if (res && res.length > 0) {
          return true;
        }
      }
    });
    setLayoutsmenus(results);
    return function cleanup() {
      setLayoutsmenus([]);
    };
  }, [searchtext, layouts]);

  const parsedData = (data) => {
    try {
      if (typeof data === "string") {
        return JSON.parse(data);
      }
      return data;
    } catch {
      return data;
    }
  }

  function templateVisibility(templateConfig) {
    try {
      templateConfig = parsedData(templateConfig);
      // Hidewhen condition
      if (isTemplateHidden(templateConfig, currentPageData)) {
        return false;
      }
      // isPrivate condition
      if (templateConfig.isPrivate) {
        if (UserPageProfile) {
          return true;
        } else {
          return false
        }
      }
      // isSuperAdminTemplate condition
      if (templateConfig.isSuperAdminTemplate) {
        if (isUserSuperAdmin) {
          return true
        } else {
          return false
        }
      }

      return true;
    } catch (e) {
      return true;
    }
  }
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (eventValue) {
        const confirmationMessage = "You have unsaved changes. Do you really want to leave?";
        event.preventDefault();
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    };
    const handleUnload = () => {
      if (eventValue) {
        dispatch(getCurrentEventValue(false));
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, [eventValue]);
  let handleCancelPopup = () => {
    setIsMsgOpen(false);

  }
  let handleLeavePopup = () => {
    setIsMsgOpen(false);
    props.callback(menuItem);
    dispatch(getCurrentEventValue(false));
  }

  let handleMsgPopup = () => {
    setIsMsgOpen(false);
  };
  const openPreferences = () => setOpenPreferencesDialog(true);
  const closePreferences = () => setOpenPreferencesDialog(false);
  const getPublishActionItems = () => {
    return (
      <>
        <A_Button
          color="primary"
          label="Leave"
          autoFocus
          onClick={handleLeavePopup}
        />
        <A_Button
          color="default"
          label="Cancel"
          onClick={handleCancelPopup}
        />
      </>
    );
  };
  const toggleSection = (key) => {
    setCollapsedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleClick = (e, item) => {
    if (eventValue) {
      setMenuItem(item);
      setIsMsgOpen(true)
      return;
    }
    props.callback(item);
  };

  const inMenuHiddenTemplates = (templates) => {
    let toShowTemplates = templates.filter(
      (item) => {
        let parsedTemplateJson = item?.templateJson;
        if (typeof parsedTemplateJson == "string") {
          parsedTemplateJson = JSON.parse(parsedTemplateJson);
        }
        return !parsedTemplateJson?.show?.inMenuHidden;
      }
    );
    return toShowTemplates;
  };

  const visibleSections = (layoutsmenus || [])
    .slice()
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((item) => ({
      ...item,
      visibleChildren: inMenuHiddenTemplates(item.children || [])
        .filter((childItem) => templateVisibility(childItem.templateJson))
        .sort((a, b) => a.itemSortIndex - b.itemSortIndex),
    }))
    .filter(
      (item) =>
        !((item.children || []).length > 0 && item.visibleChildren.length === 0)
    );

  return (
    <>
      <div
        className={`${classes.root} ${isCompact ? classes.compactMode : ""} ${vibrant ? classes.vibrant : ""}`}
      >
        <div className={classes.header}>
          <ListItem
            button
            component="div"
            className={classes.pagesidebarClosebuttonone}
            id="sidebarclosebutton"
          >
            <A_IconButton
              size="small"
              icon={<CloseIcon />}
              onClick={() => props.callback()}
            ></A_IconButton>
          </ListItem>

          <ListItem
            component="div"
            className={classes.pagesidebarClosebutton}
          >
            <ClientLogoComponent
              clientName={clientName}
              compact={isCompact}
              vibrant={vibrant}
            />
          </ListItem>
        </div>
        <List
          ref={scrollAreaRef}
          component="nav"
          disablePadding
          aria-label="layout side menu"
          className={classes.scrollArea}
        >
        {visibleSections.length > 0
          ? visibleSections
            .map((item, index) => {
              const sectionKey = item?.name || `section_${index}`;
              const isSectionCollapsed =
                !isCompact && Boolean(collapsedSections[sectionKey]);
              const childItems = (
                <>
                  {item.visibleChildren.map((childItem, ind) => {
                      const templateConfig = parsedData(childItem.templateJson);
                      const isDisabled = isTemplateDisabled(
                        templateConfig,
                        currentPageData
                      );
                      const disabledMessage = isDisabled
                        ? getLockedMessage(templateConfig)
                        : "";
                      // the rail hides the label, so keep the name in the tooltip there
                      const disabledTooltip = isCompact
                        ? [stripMenuIconPrefix(childItem.name), disabledMessage]
                            .filter(Boolean)
                            .join(" - ")
                        : disabledMessage;
                      const listItemContent = (
                        <ListItem
                          button
                          disabled={isDisabled}
                          ref={
                            childItem.id === props.currentPageId
                              ? activeItemRef
                              : null
                          }
                          onClick={(e) => {
                            if (isDisabled) {
                              return;
                            }
                            handleClick(e, childItem);
                          }}
                          className={`${classes.layoutlist} ${classes.clickableBtns} ${childItem.id === props.currentPageId ? classes.active : ""} ${!hasMenuIcon(childItem.name) && !isCompact ? classes.noIconItem : ""}`}
                        >
                          {(hasMenuIcon(childItem.name) || isCompact) && (
                            <ListItemIcon>
                              <M_MenuIcon
                                name={childItem.name}
                                compact={isCompact}
                              />
                            </ListItemIcon>
                          )}
                          <ListItemText primary={stripMenuIconPrefix(childItem.name)} />
                          {isDisabled && (
                            <LockIcon className={classes.menuLockIcon} />
                          )}
                        </ListItem>
                      );

                      if (isDisabled) {
                        return (
                          <Tooltip
                            key={`${childItem.id}_${ind}`}
                            title={disabledTooltip}
                            placement="right"
                            arrow
                          >
                            <span className={classes.disabledItemWrap}>
                              {listItemContent}
                            </span>
                          </Tooltip>
                        );
                      }

                      return isCompact ? (
                        <Tooltip
                          key={`${childItem.id}_${ind}`}
                          title={stripMenuIconPrefix(childItem.name)}
                          placement="right"
                          arrow
                        >
                          {listItemContent}
                        </Tooltip>
                      ) : (
                        React.cloneElement(listItemContent, {
                          key: `${childItem.id}_${ind}`,
                        })
                      );
                    })}
                </>
              );

              return (
                <div
                  key={`fragment_${item.name}_${index}`}
                  className={classes.sectionWrap}
                >
                  {item && item.name ? (
                    <>
                      {index > 0 && (
                        <div className={classes.sectionDivider}></div>
                      )}
                      {isCompact ? (
                        <Tooltip
                          key={`${item.id}_${index}`}
                          title={stripMenuIconPrefix(item.name)}
                          placement="right"
                          arrow
                        >
                          <ListItem
                            component="div"
                            className={`${classes.layoutlist} ${classes.sectionLabelItem}`}
                          >
                            <ListItemText
                              className={classes.sectionLabelText}
                              primary={
                                <Typography className={classes.layoutGroup}>
                                  {getInitials(stripMenuIconPrefix(item.name))}
                                </Typography>
                              }
                            />
                          </ListItem>
                        </Tooltip>
                      ) : (
                        <ListItem
                          key={`${item.id}_${index}`}
                          button
                          component="div"
                          onClick={() => toggleSection(sectionKey)}
                          aria-expanded={!isSectionCollapsed}
                          className={`${classes.layoutlist} ${classes.sectionLabelItem} ${classes.sectionLabelButton}`}
                        >
                          <ListItemText
                            className={classes.sectionLabelText}
                            primary={
                              <Typography
                                className={classes.layoutGroup}
                                style={
                                  startsWithBackArrow(item.name)
                                    ? {
                                        fontSize: "0.84375rem",
                                        fontWeight: 600,
                                        letterSpacing: 0.1,
                                        textTransform: "none",
                                      }
                                    : undefined
                                }
                              >
                                {stripMenuIconPrefix(item.name)}
                              </Typography>
                            }
                          />
                          <ExpandMoreIcon
                            className={`${classes.sectionChevron} ${isSectionCollapsed ? classes.sectionChevronCollapsed : ""}`}
                          />
                        </ListItem>
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {item.visibleChildren.length > 0 ? (
                    isCompact ? (
                      childItems
                    ) : (
                      <Collapse in={!isSectionCollapsed} timeout="auto">
                        {childItems}
                      </Collapse>
                    )
                  ) : (
                    ""
                  )}

                </div>
              );
            })
          : ""}
        </List>
        <div className={classes.footer}>
          {isCompact ? (
            <Tooltip title={PREFERENCES_MENU_LABEL} placement="right" arrow>
              <ListItem
                button
                component="div"
                onClick={openPreferences}
                className={classes.themeFooterItem}
                aria-label="Open preferences"
              >
                <ListItemIcon>
                  <TuneIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={PREFERENCES_MENU_LABEL}
                  classes={{ primary: classes.themeFooterText }}
                />
              </ListItem>
            </Tooltip>
          ) : (
            <ListItem
              button
              component="div"
              onClick={openPreferences}
              className={classes.themeFooterItem}
              aria-label="Open preferences"
            >
              <ListItemIcon>
                <TuneIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={PREFERENCES_MENU_LABEL}
                classes={{ primary: classes.themeFooterText }}
              />
            </ListItem>
          )}
        </div>
      </div>
      <A_SimpleDialog
        open={openPreferencesDialog}
        title={PREFERENCES_DIALOG_TITLE}
        fullWidth={true}
        maxWidth={"md"}
        onClose={closePreferences}
        liquidGlass
        dialogContent={<M_Preferences />}
      />
      <A_SimpleDialog
        open={isMsgOpen}
        dialogContent=""
        closePopUp={handleMsgPopup}
        title="You have unsaved changes in the template. You can leave the page to discard the changes or cancel to continue editing and save all updates."
        dialogActions={getPublishActionItems()}
        onClose={handleMsgPopup}
      />
    </>
  );
});
M_LayoutMenu.displayName = "M_LayoutMenu";
M_LayoutMenu.propTypes = {
  callback: PropTypes.func,
  layouts: PropTypes.array,
  getLoggedInUser: PropTypes.func,
  loggedinUser: PropTypes.func,
  loggedIn: PropTypes.array,
  currentPageId: PropTypes.string,
  isRailMode: PropTypes.bool,
};
export default M_LayoutMenu;
